// extracted by mini-css-extract-plugin
module.exports = {"BarHolder":"BarGraph_BarHolder__33O0p"};